import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './tu.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import './utils/fetchInterceptor'; // Initialize fetch interceptor for JWT auth

const buildInfo = {
  app: process.env.REACT_APP_APP_NAME || 'tuui',
  imageTag: process.env.REACT_APP_IMAGE_TAG || 'unknown',
  gitSha: process.env.REACT_APP_GIT_SHA || 'unknown',
  buildTime: process.env.REACT_APP_BUILD_TIME || 'unknown',
  channel: process.env.REACT_APP_DEPLOY_CHANNEL || 'unknown'
};

console.info('Build info:', buildInfo);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
